export default [
  {
    name: "车辆转把故障（故障码 1）",
    des: "无法加速骑行",
    sug:
      "请支起车辆中撑，复位转把，重新打开电门，若依然提示此故障，请立刻停止用车，联系售后进行检查"
  },
  {
    name: "车辆刹车故障（故障码 2）",
    des: "骑行过程中捏刹车无法减速",
    sug: "请支起车辆中撑，复位刹车，重新打开电门，若依然提醒此故障，请停止用车"
  },
  {
    name: "车辆电机故障（故障码 3）",
    des: "骑行过程中捏刹车无法减速，或拧转把无法加速",
    sug: "请立刻停止用车，关闭车辆总电源开关，联系售后进行检查"
  },
  {
    name: "车辆控制器故障（故障码 4）",
    des: "车辆无法锁车，或拧转把无法加速骑行",
    sug: "请立刻停止用车，关闭车辆总电源开关，联系售后进行检查"
  },
  {
    name: "车辆电机霍尔线路异常（故障码 5）",
    des: "无法正常骑行，或骑行过程中异常抖动",
    sug: "请立刻停止用车，关闭车辆总电源，联系售后进行检查"
  },
  {
    name: "车辆电机相线线路异常（故障码 6）",
    des: "无法加速骑行，或骑行过程中异常抖动",
    sug: "请立刻停止用车，关闭车辆总电源，联系售后进行检查"
  },
  {
    name: "车辆控制器供电电压不足（故障码 8）",
    des: "车内电池电量过低，或电池额定电压与控制器的工作电压不匹配",
    sug:
      "(1) 请先确认电池电量是否过低，电量低请及时充电。<br/>\
	(2) 若步骤（1）无异常，确认车内的电池额定电压，确保插入的电池额定电压与控制器工作电压范围相符，若不相符，请立刻将车内电池移除，联系售后进行检查"
  },
  {
    name: "车辆控制器供电电压过高（故障码 9）",
    des:
      "车内电池的额定电压高于控制器工作电压范围，继续使用电池可能会损坏车辆的电机控制器",
    sug:
      "请立刻停止用车，确认车内的电池额定电压，确保插入的电池额定电压与控制器工作电压范围相符，若不相符，请立刻将车内电池移除，联系售后进行检查"
  },
  {
    name: "车辆仪表盘通讯故障（故障码 21）",
    des:
      "(1) 仪表上的数据显示不正常，或按左右转向键无法打开转向灯，或远光及近光灯无法打开；<br/>(2) 无法点亮仪表",
    sug: "为确保您的行车安全，请夜间尽量不要用车，转向时务必注意观察周围行车"
  },
  {
    name: "右仓 电池通讯故障（故障码 25）",
    des: "电池停止给车辆供电",
    sug: "请联系售后进行检查"
  },
  {
    name: "左仓 电池通讯故障（故障码 125）",
    des: "电池停止给车辆供电",
    sug: "请联系售后进行检查"
  },
  {
    name: "车辆中心控制器通信故障（故障码 31）",
    des: "行驶速度将限制在 10km/h 以内，或车辆数据传输中断",
    sug: "请联系售后进行检查"
  },
  {
    name: "右仓 电池过放（故障码 40）",
    des: "电池进入自保护状态，停止给车辆供电",
    sug: "请立刻停止用车，尽快进行充电，若充电异常，请联系售后进行检查"
  },
  {
    name: "左仓 电池过放（故障码 140）",
    des: "电池进入自保护状态，停止给车辆供电",
    sug: "请立刻停止用车，尽快进行充电，若充电异常，请联系售后进行检查"
  },
  {
    name: "右仓 电池电压过低（故障码 41）",
    des:
      "系统检测到您的车辆电池放电电压过低，继续使用车辆会影响电池寿命，车辆的电池电量已耗尽",
    sug: "请立刻停止用车，尽快进行充电，继续使用车辆将影响电池寿命"
  },
  {
    name: "左仓 电池电压过低（故障码 141）",
    des:
      "系统检测到您的车辆电池放电电压过低，继续使用车辆会影响电池寿命，车辆的电池电量已耗尽",
    sug: "请立刻停止用车，尽快进行充电，继续使用车辆将影响电池寿命"
  },
  {
    name: "右仓 充电温度过高（故障码 47）",
    des: "停止充电，电池进入高温保护状态",
    sug: "建议您移除充电器，等待电池温度恢复到正常温度"
  },
  {
    name: "左仓 充电温度过高（故障码 147）",
    des: "停止充电，电池进入高温保护状态",
    sug: "建议您移除充电器，等待电池温度恢复到正常温度"
  },
  {
    name: "右仓 放电温度过高（故障码 48）",
    des: "电池进入高温保护状态，停止给车辆供电",
    sug: "建议您移除充电器，等待电池温度恢复到正常温度"
  },
  {
    name: "左仓 放电温度过高（故障码 148）",
    des: "电池进入高温保护状态，停止给车辆供电",
    sug: "建议您移除充电器，等待电池温度恢复到正常温度"
  },
  {
    name: "车辆日行灯故障（故障码 50）",
    des: "日行灯无法点亮",
    sug: "为确保您的行车安全，请尽量不要在光线不好的环境下行车"
  },
  {
    name: "车辆尾灯故障（故障码 51）",
    des: "车辆尾灯无法点亮",
    sug: "为确保您的行车安全，转向时务必注意观察周围行车"
  },
  {
    name: "车辆左转向灯故障（故障码 52）",
    des: "左转向灯无法点亮",
    sug: "为确保您的行车安全，转向时务必注意观察周围行车"
  },
  {
    name: "车辆右转向灯故障（故障码 53）",
    des: "右转向灯无法点亮",
    sug: "为确保您的行车安全，转向时务必注意观察周围行车"
  },
  {
    name: "车辆远光灯故障（故障码 54）",
    des: "远光灯无法点亮",
    sug: "为确保您的行车安全，请尽量不要夜间用车"
  },
  {
    name: "车辆近光灯故障（故障码 55）",
    des: "近光灯无法点亮",
    sug: "为确保您的行车安全，请尽量不要夜间用车"
  },
  {
    name: "车辆机油保养",
    des: "车辆的传动系统受损，导致车辆无法正常骑行",
    sug: "请立即更换机油，继续行驶可能损坏传动系统"
  }
];



// WEBPACK FOOTER //
// ./src/assets/js/helpMultilngual/bs_troubles.js